import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Index',
    component: Index,
    beforeEnter: (to, from, next) => {
      const isLogin = localStorage.getItem('isLogin')
      const expireTime = localStorage.getItem('loginExpire')
      if (!isLogin || (expireTime && Date.now() > Number(expireTime))) {
        localStorage.removeItem('isLogin')
        localStorage.removeItem('loginExpire')
        next('/login')
      } else {
        next()
      }
    }
  }
]

const router = new VueRouter({
  routes
})

export default router